import { render, staticRenderFns } from "./ViewNoCompany.vue?vue&type=template&id=6c8753f8&"
import script from "./ViewNoCompany.vue?vue&type=script&lang=js&"
export * from "./ViewNoCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports